import { getCommonReplacements } from '@src/utils/meta';
import { BASE_URL } from 'entities/Seo/config';
import type { ICreateSchemaParams } from 'entities/Seo/types';

import { mapMicrocreditToSchema } from './mapMicrocreditToSchema';

export const mapMicrocreditsToProduct = ({
  seo,
  microcredits,
  metadata,
  currentLocation,
  path,
}: ICreateSchemaParams) => ({
  '@type': 'ItemList',
  '@id': `${BASE_URL}${path}#offers`,
  name: getCommonReplacements({ template: seo.title, meta: metadata, location: currentLocation }),
  description: getCommonReplacements({
    template: seo.description,
    meta: metadata,
    location: currentLocation,
  }),
  numberOfItems: microcredits.total,
  itemListOrder: 'https://schema.org/ItemListOrderDescending',
  itemListElement: microcredits.items.map((item, index) => mapMicrocreditToSchema(path, item, index)),
});
